/**
 * @generated SignedSource<<24393b00524a144a4aa55888bbddcc12>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type searchResultRenderer_AtlassianSearchPage$data = {
  readonly __typename: string;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"searchAssetsObjectSchema_AtlassianSearchPage" | "searchAssetsObjectType_AtlassianSearchPage" | "searchAssetsObject_AtlassianSearchPage" | "searchAtlasGoal_AtlassianSearchPage" | "searchAtlasProject_AtlassianSearchPage" | "searchCompassComponent_AtlassianSearchPage" | "searchConfluencePageBlogAttachment_AtlassianSearchPage" | "searchConfluenceSpace_AtlassianSearchPage" | "searchDefaultRenderer_AtlassianSearchPage" | "searchFederatedResult_AtlassianSearchPage" | "searchGraphCode_AtlassianSearchPage" | "searchGraphResult_AtlassianSearchPage" | "searchJiraBoard_AtlassianSearchPage" | "searchJiraDashboard_AtlassianSearchPage" | "searchJiraFilter_AtlassianSearchPage" | "searchJiraIssue_AtlassianSearchPage" | "searchJiraPlan_AtlassianSearchPage" | "searchJiraProject_AtlassianSearchPage" | "searchLoomEntity_AtlassianSearchPage" | "searchLoomVideo_AtlassianSearchPage" | "searchMercuryAsk_AtlassianSearchPage" | "searchMercuryFocusAreaUpdate_AtlassianSearchPage" | "searchMercuryFocusArea_AtlassianSearchPage" | "searchMercuryRisk_AtlassianSearchPage" | "searchPassionfruitAsk_AtlassianSearchPage" | "searchTalentPosition_AtlassianSearchPage" | "searchTrello_AtlassianSearchPage">;
  readonly " $fragmentType": "searchResultRenderer_AtlassianSearchPage";
};
export type searchResultRenderer_AtlassianSearchPage$key = {
  readonly " $data"?: searchResultRenderer_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResultRenderer_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "includeJiraLiteModeFields",
  "variableName": "includeJiraLiteModeFields"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeAssets"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCaseEmbeddedComments"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCodeSearch"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeDatasourceId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeFastJiraHydration"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeMercuryAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeRisk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResultRenderer_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchAtlasGoal_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchAtlasProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchFederatedResult_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchCompassComponent_AtlassianSearchPage"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeNavBoostScore",
          "variableName": "includeNavBoostScore"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchConfluenceSpace_AtlassianSearchPage"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeCaseEmbeddedComments",
          "variableName": "includeCaseEmbeddedComments"
        },
        {
          "kind": "Variable",
          "name": "includeDatasourceId",
          "variableName": "includeDatasourceId"
        },
        {
          "kind": "Variable",
          "name": "includeThirdPartyId",
          "variableName": "includeThirdPartyId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "searchGraphResult_AtlassianSearchPage"
    },
    {
      "condition": "includeCodeSearch",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchGraphCode_AtlassianSearchPage"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "includeFastJiraHydration",
          "variableName": "includeFastJiraHydration"
        },
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "searchJiraIssue_AtlassianSearchPage"
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "searchJiraProject_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraPlan_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraBoard_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraDashboard_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchJiraFilter_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchLoomEntity_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchLoomVideo_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchMercuryFocusArea_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "searchMercuryFocusAreaUpdate_AtlassianSearchPage"
    },
    {
      "condition": "includeRisk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchMercuryRisk_AtlassianSearchPage"
        }
      ]
    },
    {
      "condition": "includeMercuryAsk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchMercuryAsk_AtlassianSearchPage"
        }
      ]
    },
    {
      "condition": "includePassionfruitAsk",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchPassionfruitAsk_AtlassianSearchPage"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "searchTrello_AtlassianSearchPage"
    },
    {
      "condition": "includeAssets",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchAssetsObjectSchema_AtlassianSearchPage"
        },
        {
          "kind": "FragmentSpread",
          "name": "searchAssetsObjectType_AtlassianSearchPage"
        },
        {
          "kind": "FragmentSpread",
          "name": "searchAssetsObject_AtlassianSearchPage"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "searchDefaultRenderer_AtlassianSearchPage"
    },
    {
      "condition": "includePositions",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "searchTalentPosition_AtlassianSearchPage"
        }
      ]
    }
  ],
  "type": "SearchResult",
  "abstractKey": "__isSearchResult"
};
})();

(node as any).hash = "917b417ab31a9cef058985817fc56ba1";

export default node;
